<template>
    <button
        type="button"
        class="btn btn-danger btn-sm ml-2"
        data-toggle="modal"
        :data-target="`#remove-agenda-${agenda.id}`"
        ref="toggle-btn"
    >
        <i class="las la-trash" />
    </button>

    <div
        class="modal fade"
        :id="`remove-agenda-${agenda.id}`"
        tabindex="-1"
        role="dialog"
        aria-labelledby="remove-agenda-label"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-md" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="remove-agenda-label">
                        {{ message }}
                    </h5>
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p class="mb-0">
                        Als de agenda is verwijderd is het niet meer mogelijk om
                        de agenda en tijdsloten terug te krijgen.
                    </p>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                        :disabled="isLoading"
                    >
                        Annuleren
                    </button>
                    <button
                        type="submit"
                        class="btn btn-danger"
                        :disabled="isLoading"
                        @click="deleteAgenda"
                    >
                        Verwijderen
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";

export default {
    name: "AgendaRemoveModal",
    props: {
        agenda: {},
    },
    methods: {
        async deleteAgenda(values) {
            try {
                let url = "/admin/api";

                url += `/agendas/${this.agenda.id}`;

                await axios.delete(url, values);

                this.$refs["toggle-btn"].click();
                this.$emit("on-update");
            } catch (e) {
                console.log(e);
            }
        },
    },
};
</script>
